import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_API } from './url.api';
import { Message } from '../model/Message.model';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(
    private http: HttpClient
  ) { }
  
  findById(messageId: number): Observable<Message> {
    return this.http.get<Message>(`${URL_API}/messages/${messageId}`);
  }

  save(message: Message): Observable<any> {
    return this.http.post<any>(`${URL_API}/messages`, message);
  }

  update(message: Message): Observable<any> {
    return this.http.put<any>(`${URL_API}/messages/${message.id}`, message);
  }

  delete(message: Message): Observable<any> {
    return this.http.delete<any>(`${URL_API}/messages/${message.id}`);
  }

  findByDestinatario(email: string): Observable<Array<Message>>{
    return this.http.get<Array<Message>>(`${URL_API}/messages/${email}/destinatario`);
  }

  findByDestAndLido(email: string): Observable<Array<Message>>{
    return this.http.get<Array<Message>>(`${URL_API}/messages/${email}/naoLidos`);
  }

  findByRemetente(email: string): Observable<Array<Message>>{
    return this.http.get<Array<Message>>(`${URL_API}/messages/${email}/remetente`);
  }

  findAll(): Observable<Array<Message>> {
    return this.http.get<Array<Message>>(`${URL_API}/messages`);
  }

}
